// extracted by mini-css-extract-plugin
module.exports = {"question":"faqQuestionContent_question__lRX26","title":"faqQuestionContent_title__lDkwu","answer":"faqQuestionContent_answer__DDleR"};